import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Button } from '@/components/common';

interface AwaitingIntegrationPanelProps {
  requestNumber?: string;
  message?: string;
  onDone: () => void;
}

/**
 * Life has no insurer adapter yet (Task 2.4's "no_adapter" path), so a
 * successful submit still returns HTTP 200 with status="no_quotes_available"
 * rather than any quotes. This is rendered as a neutral, informational panel
 * — deliberately distinct from `WizardSuccess` (green checkmark implies
 * quotes were actually returned) and from an error banner (the submission
 * itself worked fine; the request was recorded).
 */
export function AwaitingIntegrationPanel({ requestNumber, message, onDone }: AwaitingIntegrationPanelProps) {
  return (
    <div className="text-center py-8">
      <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
        <InformationCircleIcon className="w-10 h-10 text-blue-500" />
      </div>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Quote request submitted</h2>
      <p className="mt-2 text-gray-500 dark:text-gray-400 max-w-md mx-auto">
        {message || 'Awaiting insurer integration for this product line.'}
      </p>
      {requestNumber && (
        <p className="mt-1 text-sm text-gray-400 dark:text-gray-500">Reference: {requestNumber}</p>
      )}
      <p className="mt-4 text-sm text-gray-500 dark:text-gray-400 max-w-md mx-auto">
        We&rsquo;ve recorded the proposer and life-cover details you entered. Once an insurer is
        connected for life products, this request will be picked up automatically — no further
        action is needed from you.
      </p>
      <div className="mt-6 flex items-center justify-center gap-3">
        <Button variant="primary" onClick={onDone}>
          Back to Quotes
        </Button>
      </div>
    </div>
  );
}
